import { Component, Input } from '@angular/core';
import { BasketService } from '../../order-create/basket.service';
import { Store } from '../../store';

@Component({
    selector: 'app-voucher-input',
    templateUrl: './voucher-input.component.html',
    styleUrls: ['./voucher-input.component.scss'],
})
export class VoucherInputComponent {
    @Input() basket: any;
    voucherError: string;

    constructor(private store: Store, private basketService: BasketService) {}

    applyVoucher() {
        this.basketService.applyVoucher(this.basket.voucherCodeEntered).subscribe(({ data }) => {
            if (!data || data?.isExpired === '1') {
                this.basket.voucherCodeEntered = '';
                this.voucherError =
                    data?.isExpired === '1'
                        ? 'Unfortunately this code has expired'
                        : 'It looks like the code you have Entered is invalid';
            } else if (data) {
                this.basket.voucher = data;
            }
            this.store.set('basket', this.basket);
            this.basketService.calculateBasketTotal(this.basket);
        });
    }

    removeVoucher() {
        this.basketService.removeVoucher();
    }

    hideErrorMessage() {
        this.voucherError = '';
    }
}
